// extracted by mini-css-extract-plugin
export var border = "_2r-8";
export var brand = "_2r-t";
export var button = "_2r-l";
export var center = "_2r-a";
export var centered = "_2r-6";
export var closeButton = "_2r-c";
export var disabledWrapper = "_2r-m";
export var error = "_2r-p";
export var extraLarge = "_2r-4";
export var extraSmall = "_2r-1";
export var fill = "_2r-i";
export var footer = "_2r-h";
export var footerAction = "_2r-j";
export var footerButtons = "_2r-k";
export var header = "_2r-7";
export var headerWithClose = "_2r-d";
export var icon = "_2r-o";
export var info = "_2r-s";
export var inline = "_2r-9";
export var large = "_2r-3";
export var main = "_2r-e";
export var modal = "_2r-0";
export var nearFull = "_2r-5";
export var neutral = "_2r-u";
export var noPadding = "_2r-g";
export var none = "_2r-v";
export var scrollable = "_2r-f";
export var small = "_2r-2";
export var success = "_2r-r";
export var tight = "_2r-n";
export var titleIcon = "_2r-b";
export var warn = "_2r-q";